// extracted by mini-css-extract-plugin
module.exports = {"textAreaWrapper":"_9066b6c2","textArea":"_14b7b4f1","charCount":"_87ef2060"};